
// String hash function: converts an arbitrary string into a 64 bit, fixed length (11 base 62 chars) hash, similar to java's String class hashCode function
var stringHash = function(s){
    // Calculate hash: hashCode(s) = s[0]*31^(n-1) + s[1]*31^(n-2) + ... + s[n-1], with n = s.length
    var hashL = 0, hashH = 0, tempL = 0, tempH = 0; // split 64 bit number in high and low 32 bit numbers since js can't do 64 bit arithmetic (all bitwise operators treat numbers as 32 bit ints)
    for (var i = 0; i < s.length; i++) {
        tempL = hashL << 5; // temp = 32 * hash
        tempH = hashH << 5 | hashL >>> 27;
        hashH = ~hashH + (hashL == 0 ? 1 : 0); // negate hash
        hashL = ~hashL + 1;
        hashL = (tempL >>> 0) + (hashL >>> 0) + s.charCodeAt(i);    // temp  + (-hash) + char code
        hashH = tempH + hashH + (hashL > 8589934591 ? 2 : hashL > 4294967295 ? 1 : 0); // 4294967295 = 2^32 - 1, 8589934591 = 2^33 - 1
        hashL >>>= 0; hashH |= 0;   // convert to 64 bit signed int
    }

    // encode 64 bit unsigned hash 11 base 62 chars
    var base = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    var hashStr = "";
    hashH >>>= 0;
    for (var i = 0; i < 11; i++){
        var modH = hashH % 62;  // 62 = base.length
        hashStr = base[(modH * 4 + hashL) % 62] + hashStr;  // 4 = 2^32 % 62
        hashH = hashH / 62 >>> 0;
        hashL = (modH * 4294967296 + hashL) / 62 >>> 0;   // 4294967296 = 2^32
    }
    return hashStr;
};
module.exports.stringHash = stringHash;

// Strict-Equality hash function produces a hash string from an arbitrary js object wherefore: hash(objA) === hash(objB) if and only if objA === objB
var nextId = 0;
var strictEqualityHash = function(obj){
    if (obj == undefined) return obj;
    if (typeof obj === 'string') return 's_' + obj; // TODO: maybe use stringHash to shorten string
    if (typeof obj === 'number') return 'n_' + obj;
    if (typeof obj === 'boolean') return 'b_' + obj;
    if (obj._objHash) return obj._objHash;
    else {
        obj._objHash = 'o_' + (nextId++).toString(36);  //use radix 36 to reduce the length of the string
        return obj._objHash;
    }
};
module.exports.strictEqualityHash = strictEqualityHash;

// Array hash function produces a hash string from an arbitrary array, using the strictEqualityHash for each element (non-recursive)
var arrayHash = function(arr){
    if (Array.isArray(arr)){
        var hash = '';
        for (var i = 0; i < arr.length; i++){
            hash += strictEqualityHash(arr[i]) + ',';
        }
        if (hash) hash = hash.slice(0, -1);
        return '[' + hash + ']';
    } else return strictEqualityHash(arr);
};
module.exports.arrayHash = arrayHash;

// Object hash function produces a hash string from an arbitrary object, using the strictEqualityHash on each enumerable own property in the object (non-recursive)
var objectHash = function(obj){
    if (obj && typeof obj === 'object'){
        var hash = '';
        var properties = Object.keys(obj).sort();    // make sure properties appear in deterministic order in hash string
        for (var i = 0; i < properties.length; i++) {
            hash += properties[i] + ":" + strictEqualityHash(obj[properties[i]]) + ',';
        }
        if (hash) hash = hash.slice(0, -1);
        return '{' + hash + '}';
    } else return strictEqualityHash(obj);
};
module.exports.objectHash = objectHash;

// Deep-object hash function produces a hash string from an arbitrary object, recursively hashes content of objects and arrays, using strictEqualityHash for primitive objects
var deepObjectHash = function(obj){
    var hash = '';
    if (Array.isArray(obj)){
        for (var i = 0; i < obj.length; i++){
            hash += deepObjectHash(obj[i]) + ',';
        }
        if (hash) hash = hash.slice(0, -1);
        return '[' + hash + ']';
    }
    else if (obj && typeof obj === 'object'){
        var properties = Object.keys(obj).sort();    // make sure properties appear in deterministic order in hash string
        for (var i = 0; i < properties.length; i++) {
            hash += properties[i] + ":" + deepObjectHash(obj[properties[i]]) + ',';
        }
        if (hash) hash = hash.slice(0, -1);
        return '{' + hash + '}';    // TODO: this can become very long strings: maybe use stringHash to shorten string
    } else return strictEqualityHash(obj);
};
module.exports.deepObjectHash = deepObjectHash;